import { createTheme } from "@mui/material/styles";

const Table_theme = createTheme({
  typography: {
    fontWeightBold: 600, // ← prevent undefined error
  },
  components: {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          width: "100%",
          maxWidth: "100%",
          overflowX: "auto",

          borderRadius: 8,
          border: "1px solid #e0e0e0",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
        },
      },
    },
    MuiTable: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          minWidth: 650,
          borderCollapse: "separate",
          borderSpacing: 0,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "white",
        },
      },
    },
    MuiTableRow: {
  styleOverrides: {
    root: {
      height: "30px !important",
      "& .MuiTableCell-root": {
        padding: "4px 8px !important",
        height: "30px !important",
        lineHeight: "1 !important",
      },
    },
  },
},
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "12px",
          color: "#444",
          borderBottom: "1px solid #e0e0e0",
          whiteSpace: "nowrap",
        },
        head: {
          fontWeight: 600,
          fontSize: "13px",
          color: "#222",
          backgroundColor: "white",
          borderBottom: "1px solid #dcdcdc",
          textTransform: "capitalize",
        },
      },
    },
  },
  MuiTable: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-sizeSmall": {
            padding: "4px 8px !important",
            height: "30px !important",
          },
          "& .MuiTableRow-root": {
            height: "30px !important",
          },
        },
      },
    },
});

export default Table_theme;
